function importAll(r) {
  r.keys().forEach(r);
}

window.$ = $;
window.jQuery = $;
import "jquery.scrollto";
console.log("asd");
import Rails from "@rails/ujs";
Rails.start();

import "slick-carousel";
import "slick-carousel/slick/slick.css";

importAll(require.context("courses/images", true));
import "normalize.css";
import "courses/styles/courses.sass";
import "scrolldepth/jquery.scrolldepth.min.js";

let sendData = function(name){
  gtag('event', 'click', {
    'event_category': 'Курсы промо',
    'event_label': name
  })
}

jQuery(function(){
  $(".b24-form-btn").on("click", function(){
    sendData("Заявка")
  });
})
